<template>
  <div>
  <div class="footer">
      <div class="print-ctnr">
        <div class="flex-total">
      <h3>Print : </h3>
      <h3>Total Records : {{ this.selectedRecordsCount }}</h3>
    </div>
      <BrowseTrWorkFIleFilters :baseCrudKey="baseCrudKey"
      :handletrWorkFileRecords="handletrWorkFileRecords"/>
      <div class="btns-ctnr">
          <div class="btns">
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary" small rounded
                      @click="printStatement"
                      >
                          STATEMENTS
                      </v-btn>
                  </template>
                  <span>Statments</span>
              </v-tooltip>
              <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary"
                      small rounded @click="openInfoListDialog">
                          Info List
                      </v-btn>
                  </template>
                  <span>Info List</span>
              </v-tooltip>
              <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary" small rounded
                      @click="openDetailsDialog">
                          Fees List
                      </v-btn>
                  </template>
                  <span>Fees List</span>
              </v-tooltip>
              <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="primary" small rounded
                    @click="printAddressLabel">
                          Labels
                      </v-btn>
                  </template>
                  <span>Labels</span>
              </v-tooltip>
              <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary"
                      small rounded @click="printCertifiedMailersReport">
                          Certified Mailers
                      </v-btn>
                  </template>
                  <span>Certified Mailers</span>
              </v-tooltip>
              <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on"
                      color="primary" small rounded @click="printPersonalLienDocket">
                          Personal Lien Docket
                      </v-btn>
                  </template>
                  <span>Personal Lien Docket</span>
              </v-tooltip>
          </div>
          <div class="btns">
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary"
                      small rounded
                      @click="openNotificationLetterDialog">
                          Notification Letter
                      </v-btn>
                  </template>
                  <span>Delinquent Real Estate Notification Letter</span>
              </v-tooltip>
              <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary"
                      small rounded @click="openDialog">
                          Courtesy Letter
                      </v-btn>
                  </template>
                  <span>Delinquent Personal Tax Warrant Courtesy Letter</span>
              </v-tooltip>
              <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary"
                      small rounded @click="printMobileHomeReport">
                          Mobile Home
                      </v-btn>
                  </template>
                  <span>Mobile Home Delinquent letter to Land Owner</span>
              </v-tooltip>
              <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary"
                      small rounded @click="openDelinquentPersonalLetterDialog">
                         Delq Personal Letter
                      </v-btn>
                  </template>
                  <span>Delinquent Personal Letter</span>
              </v-tooltip>
              <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary"
                      small rounded @click="printInfoListByMTGCodeReport">
                          Info List By MTG Code
                      </v-btn>
                  </template>
                  <span>Info List By MTG Code***</span>
              </v-tooltip>
              <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary"
                      small rounded @click="handleBulkEmailStatements"
                      :disabled="bulkEmailStarting">
                          Email Statements
                      </v-btn>
                  </template>
                  <span>Email Statements to records with email addresses</span>
              </v-tooltip>
          </div>
      </div>
  </div>
      <div class="stmt-setting">
      <v-row dense>
          <v-col>
          <h3>Statement Settings :</h3>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
          <p>Penalty Date :</p>
      </v-col>
                  <v-col>
                      <ClarionDateControl class="input-text-size pa-0 ma-0 mt-n6"
                  :isRequired="false" :isIsoDate="false" v-model="penaltyDateForStatement"
                    :isToggle="false"
                  label="MM/DD/YYYY"/>

      </v-col>
      </v-row>
      <v-row dense class="align-center mb-n8 py-0">
          <v-col >
              <h4>Middle Section :</h4>
          </v-col>

      </v-row>
      <v-row dense class="mt-2">
          <v-radio-group row dense v-model="editItem.middleSectionPrint"
                         @change="autoSaveStatementSettings">
              <v-radio  label="Default" value="secondHalf"
              ></v-radio>
          <v-radio label="Message Text" value="messageText"
          ></v-radio>
          <v-spacer></v-spacer>
          <v-radio label="'if Paid By' Grid" value="grid"
          ></v-radio>
          </v-radio-group>
      </v-row>
      <v-row dense class="mt-n4">
              <v-checkbox
      class="input-text-size radio-and-checekbox-size"
            label="Print grid and message"
            v-model="editItem.printGridAndMessageFromTrWorkFile"
          ></v-checkbox>
            </v-row>
      <v-row dense>
          <v-col>
              <p>If Paid By dates :</p>
          </v-col>
          <v-col>
              <ClarionDateControl class="input-text-size pa-0 ma-0 mt-n2"
                  :isRequired="false" :isIsoDate="false" v-model="editItem.ifPaidBy1"
                    :isToggle="false"
                  @input="autoSaveStatementSettings"
                  outlined
                  label="MM/DD/YYYY"/>

      </v-col>
      </v-row>
      <v-row dense>
          <v-col>
          </v-col>
      <v-col cols="6">
          <ClarionDateControl class="input-text-size pa-0 ma-0 mt-n6"
                  :isRequired="false" :isIsoDate="false" v-model="editItem.ifPaidBy2"
                  :isToggle="false"
                  @input="autoSaveStatementSettings"
                  label="MM/DD/YYYY"/>

      </v-col>
      </v-row>
      <v-row dense>
          <v-col>
          </v-col>
      <v-col cols="6">
          <ClarionDateControl class="input-text-size pa-0 ma-0 mt-n6"
                  :isRequired="false" :isIsoDate="false" v-model="editItem.ifPaidBy3"
                    :isToggle="false"
                  @input="autoSaveStatementSettings"
                  outlined
                  label="MM/DD/YYYY"/>
      </v-col>
      </v-row>

      </div>
      <div class="print-stmt">
          <v-row dense>
              <v-col>
                  <h4>Generate Export Files : </h4>
              </v-col>
          </v-row>
          <v-row dense>
              <v-col>
                  <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary" small rounded
                      @click="delqTaxCsvExport">
                          Delq Tax CSV
                      </v-btn>
                  </template>
                  <span>3rd Party Tax Roll Delq Tax CSV</span>
              </v-tooltip>
              </v-col>
          </v-row>
          <v-row dense>
              <v-col>
                  <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary" small rounded
                      @click="delqTaxTextExport">
                          3rd Party TXT
                      </v-btn>
                  </template>
                  <span>3rd Party TXT</span>
              </v-tooltip>
              </v-col>
          </v-row>
          <v-row dense>
              <v-col>
                  <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary" small rounded
                      @click="openPublicationDialog">
                          Publication TXT
                      </v-btn>
                  </template>
                  <span>Deliquent Publication TXT</span>
              </v-tooltip>
              </v-col>
          </v-row>
          <v-row dense>
              <v-col>
                  <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" color="primary" small rounded
                      @click="mtgCoExport">
                       Mtg Co Export
                      </v-btn>
                  </template>
                  <span>Mtg Co Export</span>
              </v-tooltip>
              </v-col>
          </v-row>
          <v-row dense>
            <v-col>
            <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" color="primary" small rounded @click="trExportCsv">
                TR EXPORT CSV
              </v-btn>
            </template>
            <span>TR EXPORT CSV</span>
            </v-tooltip>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
                <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" color="primary" small rounded
                    @click="certMailExport" >
                        Cert Mail XLSX
                  </v-btn>
                </template>
                <span>Cert Mail XLSX (Covius/Walz upload file)</span>
            </v-tooltip>
            </v-col>
          </v-row>
      </div>
      <div />
  </div>
  <v-dialog v-model="openPrintDetailsDialog" max-width="300">
    <v-card>
      <v-card-title class="input-text-size">Report Mode</v-card-title>
      <v-card-text class="input-text-size" >
          <v-row dense>
              <v-checkbox hide-details label="Print Detail" v-model= "printDetails"></v-checkbox>
          </v-row>
    </v-card-text>
    <v-card-actions class="input-text-size">
        <v-btn color="primary" small @click="printFeesList"
          >Print</v-btn
        >
        <v-btn small @click="closePrintDetailsDialog">Cancel</v-btn>
      </v-card-actions>

    </v-card>

  </v-dialog>
  <v-dialog v-model="infoListDialog" max-width="300">
      <v-card>
        <v-card-title class="input-text-size">
          Report Mode
        </v-card-title>
        <v-card-text class="input-text-size" >
            <v-row dense>
              <v-checkbox hide-details label="Page Breaks by Code" v-model= "isPageBreaks">
              </v-checkbox>
                <v-checkbox hide-details label="Print Detail" v-model= "fullLegalDescription">
                </v-checkbox>
                <v-spacer></v-spacer>
                <v-checkbox hide-details label="Single Line info List"
                v-model="singleLineInfo"></v-checkbox>
                <v-checkbox
                hide-details
                label="Include Half Pay Amounts"
                v-model= "isIncludeHalfPayAmounts"
                >
                </v-checkbox>
            </v-row>
      </v-card-text>
      <v-card-actions class="input-text-size">
          <v-btn color="primary" small @click="printInfoList"
            >Print</v-btn
          >
          <v-btn color="primary" small @click="handleEmailInfoList"
            >Email</v-btn
          >
          <v-btn small @click="closeInfoListDialog">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <CRUDDialog
        :baseCrudKey='emailStatementCrudKeyTR'
        :canSave="true"
        canSaveCustomLabel="Send"
        :onlyDialogHeaderName="emailStatementHeader"
        dialogDynamicWidth='550'
        @upsertItem="handleEmail"
      ><template v-slot:[`editedItem`]="{}">
          <EmailStatementDialoge :baseCrudKey="emailStatementCrudKeyTR" />
        </template>
      </CRUDDialog>
    <PublicationDialog
      v-model="showPublicationDialog"
      :header="publicationHeader"
      :taxInquiryData="items('publicationTaxInquiryData')"
      :browseListData="items('browseListNames')"
      @generate="handlePublicationGenerate"
    />
  <v-dialog v-model="courtesyDialog" max-width="300" class="input-text-size">
    <v-card>
      <v-card-title class="input-text-size">Enter Details</v-card-title>
      <v-card-text class="input-text-size" >
        <ClarionDateControl class="input-text-size"
                label="Letter Date" :isRequired="false" :isToggle="false"
                  :isIsoDate="false" v-model="letterDate" />
        <ClarionDateControl class="input-text-size"
                label="Warrant Date" :isRequired="false" :isToggle="false"
                  :isIsoDate="false" v-model="warrantDate" />
          <v-text-field label="warrant Fee" v-model="warrantFee"></v-text-field>
      </v-card-text>
      <v-card-actions class="input-text-size">
        <v-btn color="primary" small @click="printCourtesyLetterReport"
          >Save</v-btn
        >
        <v-btn small @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="bulkEmailDialog" max-width="560">
    <v-card>
      <v-card-title class="input-text-size">Email Statements</v-card-title>
      <v-card-text class="input-text-size">
        <v-container>
          <!-- Counts come from the server over the WHOLE filtered list, not from the rows
               the grid happens to have loaded, and the skipped group is stated up front
               instead of being silently dropped. -->
          <v-row dense>
            <v-col>
              <p class="mb-1">
                <strong>{{ (bulkEmailPreview.willSend || 0).toLocaleString() }}</strong>
                of <strong>{{ (bulkEmailPreview.total || 0).toLocaleString() }}</strong>
                record(s) in <em>{{ criteriaState.name }}</em> will be emailed a statement.
              </p>
              <p class="mb-1" v-if="bulkEmailPreview.noEmail">
                <strong>{{ bulkEmailPreview.noEmail.toLocaleString() }}</strong>
                record(s) have no email address and will be skipped — they appear in the run
                log so they can be routed to a printed mailing.
              </p>
              <p class="mb-1" v-if="bulkEmailPreview.skippedAlreadySent">
                <strong>{{ bulkEmailPreview.skippedAlreadySent.toLocaleString() }}</strong>
                record(s) were already emailed successfully in an earlier run and will be
                skipped.
              </p>
              <p class="mb-0 grey--text">
                The run happens on the server. You can close this page once it starts.
              </p>
            </v-col>
          </v-row>
          <v-checkbox class="input-text-size mt-0" hide-details
            label="Send again to records already emailed in an earlier run"
            :input-value="!bulkEmailExcludeAlreadySent"
            @change="onToggleResendAlreadySent" />
          <v-text-field class="input-text-size" label="BCC"
            v-model="bulkEmailSettings.bccEmailAddress" />
          <v-text-field class="input-text-size" label="Subject"
            v-model="bulkEmailSettings.subjectLine" />
          <v-textarea class="input-text-size" label="Body"
            outlined rows="4" dense v-model="bulkEmailSettings.subjectBody" />
        </v-container>
      </v-card-text>
      <v-card-actions class="input-text-size">
        <v-btn color="primary" small :disabled="!bulkEmailPreview.willSend || bulkEmailStarting"
          :loading="bulkEmailStarting" @click="executeBulkEmailStatements">Send</v-btn>
        <v-btn small @click="bulkEmailDialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- Run log: one row per record considered, on screen and downloadable, so the office can
       show who was emailed and when. -->
  <v-dialog v-model="emailLogDialog" max-width="1000" scrollable>
    <v-card>
      <v-card-title class="input-text-size">
        Email Statement Run Log
        <v-spacer />
        <span class="caption grey--text" v-if="emailLogRun">
          {{ emailLogRun.listName }} &middot; started by {{ emailLogRun.startedByUsername }}
          <template v-if="emailLogRun.wkstID != null">
            &middot; wkst {{ emailLogRun.wkstID }}
          </template>
        </span>
      </v-card-title>
      <v-card-text class="input-text-size">
        <v-row dense align="center">
          <v-col cols="auto" v-if="emailLogRun">
            <span class="mr-3">Sent: <strong>{{ emailLogRun.sent || 0 }}</strong></span>
            <span class="mr-3">Failed: <strong>{{ emailLogRun.failed || 0 }}</strong></span>
            <span class="mr-3">Skipped: <strong>{{ emailLogRun.skipped || 0 }}</strong></span>
            <!-- Non-production only. Shown only when it happened, so it never adds noise to
                 a county's real mailing. -->
            <span class="mr-3 orange--text text--darken-3" v-if="emailLogRun.redirected">
              Redirected: <strong>{{ emailLogRun.redirected }}</strong> (not sent to taxpayers)
            </span>
            <span>Total: <strong>{{ emailLogRun.total || 0 }}</strong></span>
          </v-col>
          <v-col cols="3">
            <v-select hide-details dense outlined class="input-text-size"
              label="Show" :items="emailLogStatusOptions"
              v-model="emailLogStatusFilter" @change="reloadEmailLog" />
          </v-col>
        </v-row>
        <v-data-table dense class="mt-2 input-text-size"
          :headers="emailLogHeaders" :items="emailLogRows"
          :server-items-length="emailLogTotalCount" :loading="emailLogLoading"
          :options.sync="emailLogOptions" :footer-props="{ 'items-per-page-options': [100, 250, 500] }">
          <template v-slot:[`item.status`]="{ item }">
            <span :class="emailLogStatusClass(item.status)">{{ item.status }}</span>
          </template>
          <template v-slot:[`item.sentAt`]="{ item }">
            {{ item.sentAt ? new Date(item.sentAt).toLocaleString() : '' }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="input-text-size">
        <v-btn color="primary" small @click="exportEmailLog">Export CSV</v-btn>
        <v-btn small @click="exportEmailLogSkipped"
          :disabled="!emailLogRun || !emailLogRun.skipped">Export Skipped</v-btn>
        <v-btn small color="warning" @click="retryFailedForLoggedRun"
          :disabled="!canRetryLoggedRun">Retry Failed Only</v-btn>
        <v-spacer />
        <v-btn small @click="emailLogDialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="personalLienDocketDialog" max-width="400">
    <v-card>
      <v-card-title class="input-text-size red--text">Personal Lien Docket</v-card-title>
      <v-card-text class="input-text-size">
        <v-container>
          <v-row dense>
            <v-col>
              <ClarionDateControl class="input-text-size"
                label="Date Filed" :isRequired="false" :isToggle="false"
                :isIsoDate="false" v-model="dateFiled" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="input-text-size">
        <v-btn color="primary" small @click="confirmPersonalLienDocket">Save</v-btn>
        <v-btn small @click="personalLienDocketDialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="delinquentPersonalLetterDialog" max-width="400">
  <v-card>
    <v-card-title class="input-text-size">
      Delinquent Personal Letter
    </v-card-title>
    <v-card-text class="input-text-size">
      <v-container>
        <v-row dense hide-details>
          <v-col>
            <ClarionDateControl class="input-text-size"
              label="Date of Publication" :isRequired="false" :isToggle="false"
              :isIsoDate="false" v-model="dateOfPublication" />
          </v-col>
        </v-row>
        <v-row dense hide-details>
          <v-col>
            <ClarionDateControl class="input-text-size"
              label="Date to Pay Taxes Prior to Publication" :isRequired="false" :isToggle="false"
              :isIsoDate="false" v-model="dateTaxPriorToPublication" />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions class="input-text-size">
      <v-btn color="primary" small @click="printDelinquentPersonalLetter">Save</v-btn>
      <v-btn small @click="closeDelinquentPersonalLetterDialog">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
  <v-dialog v-model="delinquentDialog" max-width="400">
  <v-card>
    <v-card-title class="input-text-size">
      Please Enter the Following Information for Delinquent Letters
    </v-card-title>
    <v-card-text class="input-text-size">
      <v-container>
        <ClarionDateControl class="input-text-size mt-n4"
            label="Penalty Calculated Through Date" :isToggle="false" v-model="editItemSetting.accessorPenaltyDate" />
        <ClarionDateControl class="input-text-size mt-n4"
            label="Lien Date" :isToggle="false" v-model="editItemSetting.accessorLienDate" />
        <ClarionDateControl class="input-text-size mt-n4"
            label="Publication Date" :isToggle="false" v-model="editItemSetting.accessorPublicationDate" />
        <v-text-field class="input-text-size mt-n4"
          label="Addressee" v-model="editItemSetting.accessorAddressee" />
        <v-text-field class="input-text-size mt-n4"
          label="Payment Forms Accepted" v-model="editItemSetting.accessorPaymentForms" />
        <v-checkbox hide-details class="input-text-size"
          label="Print with Owner Name/Address" v-model="editItemSetting.accessorPrintWithOwner" />
        <v-checkbox hide-details class="input-text-size"
          label="Print C/O Name" v-model="editItemSetting.accessorPrintCareOfName" />
        <v-checkbox hide-details class="input-text-size"
          label="Display Total Due Based on Penalty Date?" v-model="editItemSetting.accessorDisplayTotalDue" />
        <v-checkbox hide-details class="input-text-size"
          label="Include back taxes in total" v-model="editItemSetting.accessorIncludeBackTaxesInTotal"
          :disabled="!editItemSetting.accessorDisplayTotalDue" />
      </v-container>
    </v-card-text>
    <v-card-actions class="input-text-size">
      <v-btn color="primary" small @click="printNotificationLetter">
        Save
      </v-btn>
      <v-btn small @click="closeDelinquentDialog">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</div>

</template>
<script>
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import {
  mapActions,
  mapGetters, mapMutations,
  mapState,
} from 'vuex';
import { clients } from '../../../util/clients';
import { getRawJwt } from '../../../util/jwt';
import { destructureDate, toIsoDate, toShortDate } from '../../../util/shared/tmc-global';
import { transformMapperListFields } from '../../../util/shared/transform';
import { getWorkstationNumber } from '../../../util/workstation-util';
import CRUDDialog from '../../common/base/crud-2.0/CRUDDialog.vue';
import { generateQueryString } from '../../common/base/report/report-util';
import { statementConfigScope, taxConfigScope } from '../../../util/shared/system-config-scopes';
import { POST_LOAD_COMP_TIMER } from '../common-utils/constants';
import EmailStatementDialoge from '../TaxInquiry/Common/EmailStatementDialoge.vue';
import BrowseTrWorkFIleFilters from './BrowseTrWorkFIleFilters.vue';
import PublicationDialog from './PublicationDialog.vue';

const { backendRest } = clients.direct;

// KEEP IN SYNC with PICKLIST_INLINE_MAX_RECORDS in printList.js. Okmulgee measured ~6.5KB
// a record, so a thousand records is already around 6MB and roughly ten seconds to build.
// That backend value is env-overridable and this one is baked into the bundle, so ops
// raising it there without a redeploy here makes the two disagree. The disagreement is
// benign - the backend guards hold either way, and the worst case is a run taking the
// sync path when it would have been better queued - but it is a real trap.
const PICKLIST_ASYNC_MIN_RECORDS = 1000;

export default {
  name: 'trWorkFileFooter',
  data() {
    return {
      middleSectionPrint: null,
      printDetails: false,
      courtesyDialog: false,
      letterDate: null,
      warrantDate: null,
      warrantFee: null,
      delinquentDialog: false,
      openPrintDetailsDialog: false,
      infoListDialog: false,
      singleLineInfo: false,
      fullLegalDescription: false,
      isPageBreaks: false,
      isIncludeHalfPayAmounts: false,
      emailStatementHeader: 'Email Send',
      emailStatementCrudKeyTR: 'emailStatementTR',
      bulkEmailDialog: false,
      bulkEmailStarting: false,
      // Server's answer for the whole filtered list, not a count of loaded rows.
      bulkEmailPreview: {
        total: 0, willSend: 0, noEmail: 0, skippedAlreadySent: 0,
      },
      bulkEmailExcludeAlreadySent: true,
      bulkEmailSettings: {
        bccEmailAddress: '',
        subjectLine: '',
        subjectBody: '',
      },
      emailLogDialog: false,
      emailLogRunId: null,
      emailLogRun: null,
      emailLogRows: [],
      emailLogTotalCount: 0,
      emailLogLoading: false,
      emailLogStatusFilter: '',
      emailLogOptions: {},
      emailLogStatusOptions: [
        { text: 'All records', value: '' },
        { text: 'Sent', value: 'sent' },
        { text: 'Failed', value: 'failed' },
        { text: 'Skipped', value: 'skipped-no-email,skipped-already-sent' },
        { text: 'Skipped — no email address', value: 'skipped-no-email' },
        { text: 'Redirected (non-production)', value: 'redirected' },
        { text: 'Not reached', value: 'pending' },
      ],
      emailLogHeaders: [
        { text: 'Tax Id', value: 'taxId' },
        { text: 'Year', value: 'taxYear' },
        { text: 'Owner Name', value: 'ownerName' },
        { text: 'Email Address', value: 'emailAddress' },
        { text: 'Status', value: 'status' },
        { text: 'Reason / Error', value: 'errorMessage' },
        { text: 'Sent At', value: 'sentAt' },
      ],
      publicationCrudKey: 'publicationTXT',
      publicationHeader: 'Publication TXT Settings',
      wkstNumber: getWorkstationNumber(),
      autoSaveTimeout: null,
      // New isolated publication dialog
      showPublicationDialog: false,
      penaltyDateForStatement: toShortDate(),
      delinquentPersonalLetterDialog: false,
      dateOfPublication: toShortDate(),
      dateTaxPriorToPublication: toShortDate(),
      personalLienDocketDialog: false,
      dateFiled: toShortDate(),
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
    handletrWorkFileRecords: {
      type: Function,
      default: () => ({}),
    },
  },
  components: {
    ClarionDateControl,
    BrowseTrWorkFIleFilters,
    EmailStatementDialoge,
    CRUDDialog,
    PublicationDialog,
  },
  async created() {
    // Non-reactive on purpose: these are setTimeout handles, not view state.
    // Must be initialised before the resume loop below reads it.
    this.pollTimers = {};
    // Load statement config first
    await this.loadConfig({ requiredScope: 'statementConfig' });
    await this.loadConfig({ requiredScope: 'taxConfig' });
    this.calculatePenaltyThrough();
    // Resume polling for any jobs that were still running when we last left this page
    this.resumeStatementJobs();
    // ...and ask the server for anything this browser never knew about. The queue is held
    // in memory, so a refresh loses every job id and a run that is still going becomes
    // unreachable even though it finishes server-side.
    this.recoverStatementJobs();
  },
  watch: {
    // The parent renders the queue rows and drives Check again, so a job can become live
    // again without the footer knowing. Re-attaching here keeps that one-way: the parent
    // only has to update the store.
    statementJobs() {
      this.resumeStatementJobs();
    },
    // Server-side paging for the run log: a county-wide mailing has far too many rows to
    // hand the table in one go.
    emailLogOptions: {
      deep: true,
      handler() {
        if (this.emailLogDialog) this.reloadEmailLog();
      },
    },
  },
  computed: {
    statementJobs() {
      return this.$store.state.tax.trWorkFile.statementJobs || [];
    },
    ...mapGetters('base/crud', [
      'criteria',
      'items',
      'item',
      'selectedTab',
    ]),
    ...mapState({
      StoreSelItems: (state) => state.tax.trWorkFile.selectedItems,
      statementSettingItem: (state) => state.SystemConfig.statementSettingItem || {},
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
      StoreTotalCount: (state) => state.tax.trWorkFile.totalTRRecordsCount,
    }),
    editItemSetting() {
      return this.taxSettingItem;
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    tabsInit: {
      get() {
        return this.selectedTab(this.baseCrudKey);
      },
      set(value) {
        this.setSelectedTab([this.baseCrudKey, value]);
      },
    },
    selectedRecordsCount: {
      get() {
        return this.StoreTotalCount;
      },
      set(value) {
        this.settotalTRRecordsCount(value);
      },
    },
    editItem() {
      return this.statementSettingItem;
    },
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setSelectedItems(value);
      },
    },
    editEmailItem: {
      get() {
        return this.item(this.emailStatementCrudKeyTR);
      },
      set(value) {
        this.setItem([this.emailStatementCrudKeyTR, value]);
      },
    },
    // Retry is offered only once the run has stopped and only when there is something to
    // retry - re-running a live job would double-send to whoever it is mid-way through.
    canRetryLoggedRun() {
      const run = this.emailLogRun;
      if (!run) return false;
      return !['queued', 'pending', 'running'].includes(run.status) && (run.failed || 0) > 0;
    },
  },
  methods: {
    ...mapActions(['custumColrFlashMsg']),
    ...mapMutations('tax/trWorkFile', [
      'setSelectedItems',
      'addStatementJob',
      'updateStatementJob',
      'removeStatementJob',
    ]),
    ...mapMutations('base/crud', ['setIsVisible', 'setCriteria', 'setItem', 'setItems', 'setSelectedTab']),
    ...mapActions('SystemConfig', [
      'loadConfig', 'updateConfig',
    ]),
    ...mapActions('config', [
      'loadTransformMappers',
    ]),
    ...mapActions(['reAuth']),
    ...mapActions('tax/trWorkFile', [
      'sendMailTR',
      'previewBulkEmailStatements',
      'startBulkEmailStatementsRun',
      'loadBulkEmailRunLog',
      'retryFailedBulkEmails',
    ]),
    ...mapActions('tax/taxInquires', [
      'loadTaxInquires',
      'callToUpdateTaxGlobalVariable',
    ]),
    updateStatementSettings() {
      if (window.confirm('Are you sure want to update this configuration?')) {
        const payload = {
          calledScope: 'statementConfig',
          item: statementConfigScope.mergeForPersist(this.editItem),
        };
        this.updateConfig(payload);
      }
    },
    formatStringValue(data, addComma = false) {
      if (data === undefined || data === null) {
        return '';
      }
      return addComma ? `${data},` : `${data}`;
    },
    autoSaveStatementSettings() {
      // Clear any existing timeout
      if (this.autoSaveTimeout) {
        clearTimeout(this.autoSaveTimeout);
      }

      // Set a new timeout to save after 500ms of inactivity
      this.autoSaveTimeout = setTimeout(() => {
        const payload = {
          calledScope: 'statementConfig',
          item: statementConfigScope.mergeForPersist(this.editItem),
        };
        this.updateConfig(payload);
      }, POST_LOAD_COMP_TIMER);
    },
    openDetailsDialog() {
      this.openPrintDetailsDialog = true;
    },
    openInfoListDialog() {
      this.infoListDialog = true;
    },
    closeInfoListDialog() {
      this.infoListDialog = false;
    },
    closePrintDetailsDialog() {
      this.openPrintDetailsDialog = false;
    },
    openDialog() {
      this.courtesyDialog = true;
    },
    closeDialog() {
      this.courtesyDialog = false;
    },
    openNotificationLetterDialog() {
      this.delinquentDialog = true;
    },
    closeDelinquentDialog() {
      this.delinquentDialog = false;
    },
    openDelinquentPersonalLetterDialog() {
      this.delinquentPersonalLetterDialog = true;
    },
    closeDelinquentPersonalLetterDialog() {
      this.delinquentPersonalLetterDialog = false;
    },
    async printDelinquentPersonalLetter() {
      const { jwt } = await this.reAuth();
      const criteria = this.criteriaState;
      criteria.sortBy = [{ column: this.dynamicSortBy(), direction: 'asc' }];
      if (!criteria.name) {
        window.confirm('please select file name to proceed');
        return;
      }
      if (this.tabsInit === 6) {
        if (!(this.selectedItems || []).length) {
          this.custumColrFlashMsg({ msg: 'Please select a record' });
          return;
        }
        criteria.ids = this.selectedItems.map((item) => item._id).join(',');
      } else {
        delete criteria.ids;
      }
      const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));
      const params = [
        `token=${jwt}`,
        `filters=${encodedCriteria}`,
        `dateOfPublication=${toIsoDate(this.dateOfPublication)}`,
        `dateTaxPriorToPublication=${toIsoDate(this.dateTaxPriorToPublication)}`,
      ];
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      const queryString = generateQueryString(params);
      const to = `trWorkFile/deliquent/personal-letter${queryString}`;
      const url = `${backendRest.defaults.baseURL}/${to}`;
      window.open(url);
      this.closeDelinquentPersonalLetterDialog();
    },
    async openPublicationDialog() {
      // Get filter criteria from browseListNames
      const browseItems = this.items('browseListNames');
      if (!browseItems || browseItems.length === 0) {
        this.custumColrFlashMsg({ msg: 'No browse list data available' });
        return;
      }

      const firstItem = browseItems[0];
      const { taxId, taxYear } = firstItem;

      if (!taxId || !taxYear) {
        this.custumColrFlashMsg({ msg: 'Missing taxId or taxYear in browse data' });
        return;
      }

      try {
        // Call tax inquiry API to get complete tax data
        await this.loadTaxInquires({
          criteria: { taxId, taxYear },
          baseCrudKey: 'publicationTaxInquiryData',
        });

        // Open the new isolated dialog
        this.showPublicationDialog = true;
      } catch (error) {
        this.custumColrFlashMsg({ msg: 'Error loading tax inquiry data' });
      }
    },
    async handlePublicationGenerate(publicationSettings) {
      // Handle generation from the new isolated dialog
      this.generatePublicationWithSettings(publicationSettings);
    },
    async generatePublicationWithSettings(publicationSettings) {
      const { jwt } = await this.reAuth();
      const criteria = this.criteriaState;

      if (!criteria.name) {
        window.confirm('please select file name to proceed');
        return;
      }

      if (this.tabsInit === 6) {
        // if selected filter index is 6, then we need to generate for selected records
        if (!(this.selectedItems || []).length) {
          this.custumColrFlashMsg({ msg: 'Please select a record' });
          return;
        }
        criteria.ids = this.selectedItems.map((item) => item._id).join(',');
      } else {
        delete criteria.ids;
      }

      const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));

      // Extract values from the publication settings
      const {
        taxId, parcelId, ownerName, taxType, includeDelinquents, includeNameTwo, includeCareOf,
        taxPenaltyFeesDue, totalDue, singleLineNameAmount, descriptionType, amountDisplayType, printOrder, penaltyDate,
        combineRecords,
      } = publicationSettings;

      const params = [
        `token=${jwt}`,
        `filters=${encodedCriteria}`,
        `includeTaxId=${Boolean(taxId)}`,
        `includeParcelId=${Boolean(parcelId)}`,
        `includeOwnerName=${Boolean(ownerName)}`,
        `includeTaxType=${Boolean(taxType)}`,
        `includeDelinquents=${Boolean(includeDelinquents)}`,
        `includeNameTwo=${Boolean(includeNameTwo)}`,
        `includeCareOf=${Boolean(includeCareOf)}`,
        `includeLegalDescription=${descriptionType === 'legalDescription'}`,
        `includeAdditionLotAndBlock=${descriptionType === 'additionLotAndBlock'}`,
        `includeTaxPenaltyFeesDue=${Boolean(taxPenaltyFeesDue)}`,
        `includeTotalDue=${Boolean(totalDue)}`,
        `singleLineNameAmount=${Boolean(singleLineNameAmount)}`,
        `includeTotalDueOnly=${amountDisplayType === 'totalDueOnly'}`,
        `includeSeparateAmounts=${amountDisplayType === 'separateAmounts'}`,
        `orderByName=${printOrder === 'orderOwnerName'}`,
        `orderByTaxId=${printOrder === 'orderTaxId'}`,
        `orderByParcelId=${printOrder === 'orderPID'}`,
        `penaltyDate=${toIsoDate(penaltyDate)}`,
        // Groups the work-file rows by property (baseId, else parcel ID) and prints one header
        // and one combined Total Due per property instead of one section per row.
        `combineRecords=${Boolean(combineRecords)}`,
      ];

      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }

      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/trWorkFile/publication-txt${queryString}`;
      window.open(url, '_blank');

      // Close the dialog after generating
      this.setIsVisible([this.publicationCrudKey, false]);
    },
    dynamicSortBy() {
      const criteria = this.criteriaState;
      if (criteria.ownerNameFrom || criteria.ownerNameTo) {
        return 'ownerName';
      } if (criteria.fromTaxId || criteria.toTaxId) {
        return 'taxId';
      } if (criteria.parcelIdFrom || criteria.parcelIdTo) {
        return 'propertyOrParcelId';
      }
      if (criteria.incfromMtgCode || criteria.inctoMtgCode) {
        return 'mtgCode';
      }
      return 'taxId';
    },
    buildLabelSortBy() {
      const sortByColumn = this.dynamicSortBy();
      const sortBy = [{ column: sortByColumn, direction: 'asc' }];
      if (sortByColumn === 'ownerName') {
        sortBy.push({ column: 'taxId', direction: 'asc' });
      }
      return sortBy;
    },
    async printStatement() {
      const { jwt } = await this.reAuth();
      const criteria = this.criteriaState;
      criteria.sortBy = [{ column: this.dynamicSortBy(), direction: 'asc' }];
      if (!criteria.name) {
        window.confirm('please select file name to proceed');
      } else if (this.tabsInit === 6) {
        // if selected filter index is 6, then we need to print the
        //  statement for the selected records

        if (!(this.selectedItems || []).length) {
          this.custumColrFlashMsg({ msg: 'Please select a record' });
          return;
        }
        criteria.ids = this.selectedItems.map((item) => item._id).join(',');
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));
        const penaltyDate = toIsoDate(this.penaltyDateForStatement);
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
          `penaltyDate=${penaltyDate}`,
          'status=trworkfile',
          `wkst=${Number(this.wkstNumber)}`,
          `totalRecords=${this.selectedItems.length}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        this.startStatementJob(queryString);
      } else {
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));
        const penaltyDate = toIsoDate(this.penaltyDateForStatement);

        delete criteria.ids;
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
          `penaltyDate=${penaltyDate}`,
          'status=trworkfile',
          `wkst=${Number(this.wkstNumber)}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        this.startStatementJob(queryString);
      }
    },
    buildJobLabel(criteria) {
      if (!criteria) return `${new Date().toLocaleTimeString()} · All records`;
      const now = new Date();
      const time = now.toLocaleTimeString('en-US', {
        hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true,
      });
      let filter = '';
      if (this.tabsInit === 6 && (this.selectedItems || []).length) {
        filter = `Selected (${this.selectedItems.length.toLocaleString()})`;
      } else if (criteria.ownerNameFrom || criteria.ownerNameTo) {
        const from = (criteria.ownerNameFrom || '').trim();
        const to = (criteria.ownerNameTo || '').trim();
        filter = from && to ? `Owner: ${from} – ${to}` : `Owner: ${from || to}`;
      } else if (criteria.fromTaxId || criteria.toTaxId) {
        const from = criteria.fromTaxId || '';
        const to = criteria.toTaxId || '';
        filter = from && to ? `Tax ID: ${from} – ${to}` : `Tax ID: ${from || to}`;
      } else if (criteria.parcelIdFrom || criteria.parcelIdTo) {
        const from = (criteria.parcelIdFrom || '').trim();
        const to = (criteria.parcelIdTo || '').trim();
        filter = from && to ? `Parcel: ${from} – ${to}` : `Parcel: ${from || to}`;
      } else if (criteria.incfromMtgCode || criteria.inctoMtgCode) {
        const from = (criteria.incfromMtgCode || '').trim();
        const to = (criteria.inctoMtgCode || '').trim();
        filter = from && to ? `MTG: ${from} – ${to}` : `MTG: ${from || to}`;
      }
      return filter ? `${time} · ${filter}` : `${time} · All records`;
    },
    resumeStatementJobs() {
      (this.statementJobs || []).forEach((job) => {
        const live = ['running', 'pending', 'queued'].includes(job.status);
        if (live && job.jobId && !this.pollTimers[job.localId]) {
          this.pollStatementJob(job.localId, job.jobId, 0, job.kind || 'statement');
        }
      });
    },
    // Adopt any of this user's server-side jobs the browser is missing, so a refresh or a
    // second tab does not orphan a run.
    async recoverStatementJobs() {
      // Both kinds have to be recovered. A pick list run takes minutes, so refreshing while
      // one is going is entirely normal - and the queue only lives in browser memory, so
      // without this the job id is gone and the run becomes unreachable even though it
      // finishes server-side and the PDF waits in tmp until it expires.
      const sources = [
        { kind: 'statement', url: 'taxInquiry/pick-list/printStatement/jobs' },
        { kind: 'picklist', url: 'taxInquiry/pick-list/printlist/jobs' },
        // Email runs are recovered the same way, and matter more: a bulk mailing is the one
        // run an operator is most likely to walk away from, and its record of who was
        // emailed is the whole point.
        { kind: 'email', url: 'taxInquiry/pick-list/emailStatement/runs' },
      ];
      const results = await Promise.all(sources.map(async (source) => {
        try {
          const response = await backendRest.get(source.url);
          // The email endpoint returns `runs` keyed by runId; the print ones return `jobs`.
          const list = (response.data && (response.data.jobs || response.data.runs)) || [];
          return list.map((j) => ({ ...j, jobId: j.jobId || j.runId, kind: source.kind }));
        } catch (err) {
          return []; // best effort per source — one failing must not lose the other
        }
      }));
      const serverJobs = results.flat();
      if (this.$isDestroyed) return;
      const known = new Set((this.statementJobs || []).map((j) => j.jobId).filter(Boolean));
      serverJobs.filter((j) => !known.has(j.jobId)).forEach((j) => {
        this.addStatementJob({
          localId: Math.random().toString(36).slice(2),
          jobId: j.jobId,
          // Stamped from the source it came back on, never defaulted, so a recovered row
          // cannot end up polling the other kind's endpoint.
          kind: j.kind,
          label: j.label || 'Recovered job',
          status: j.status,
          processed: j.processed || 0,
          total: j.total || 0,
          sent: j.sent || 0,
          failed: j.failed || 0,
          skipped: j.skipped || 0,
          // A recovered run that has already finished is never polled again, so anything the
          // row needs has to come across here or it is never shown.
          redirected: j.redirected || 0,
          pdfUrl: j.pdfUrl ? `${backendRest.defaults.baseURL}/${j.pdfUrl}` : null,
          errorMessage: j.errorMessage || null,
        });
      });
    },
    // The queue carries several kinds of run. Only the endpoint base differs, so the rows,
    // polling, recovery and download all stay as they are; `kind` picks the base.
    jobEndpointBase(kind) {
      if (kind === 'picklist') return 'taxInquiry/pick-list/printlist';
      if (kind === 'email') return 'taxInquiry/pick-list/emailStatement';
      return 'taxInquiry/pick-list/printStatement';
    },
    // Bulk email runs are addressed as /run/:id rather than /job/:id, and there is no PDF at
    // the end - the artifact is the log.
    jobStatusUrl(kind, jobId) {
      return kind === 'email'
        ? `${this.jobEndpointBase(kind)}/run/${jobId}`
        : `${this.jobEndpointBase(kind)}/job/${jobId}`;
    },
    async startStatementJob(queryString, kind = 'statement') {
      const localId = Math.random().toString(36).slice(2);
      const label = this.buildJobLabel(this.criteriaState);
      // Hand the label to the server too, so a job recovered after a page refresh still
      // reads "12:13:52 PM · All records" instead of an opaque id.
      const asyncTo = `${this.jobEndpointBase(kind)}/async${queryString}`
        + `&label=${encodeURIComponent(label)}`;
      this.addStatementJob({
        localId,
        jobId: null,
        kind,
        label,
        status: 'pending',
        processed: 0,
        total: 0,
        pdfUrl: null,
        errorMessage: null,
      });
      try {
        const response = await backendRest.get(asyncTo);
        if (this.$isDestroyed) return;
        const { jobId, total } = response.data;
        this.updateStatementJob({ localId, updates: { jobId, total, status: 'running' } });
        this.pollStatementJob(localId, jobId, 0, kind);
      } catch (err) {
        const msg = (err && err.response && err.response.data && err.response.data.error)
          || (err && err.message) || 'Failed to start job';
        this.updateStatementJob({ localId, updates: { status: 'error', errorMessage: msg } });
      }
    },
    pollStatementJob(localId, jobId, attempt = 0, kind = 'statement') {
      // 60 min (2400 * 1500ms), matching the server's own cap on a running job. The old
      // 20-minute ceiling was shorter than the benchmark this feature was built against
      // (~35 min for 90K records), so the UI was guaranteed to give up on exactly the
      // county-wide runs it exists to handle.
      const MAX_POLL_ATTEMPTS = 2400;
      if (attempt >= MAX_POLL_ATTEMPTS) {
        // 'stalled', not 'error'. The job is probably still running, and marking it failed
        // made the row terminal so nothing could re-attach. This keeps the job id so the
        // user can ask the server for a straight answer.
        this.updateStatementJob({
          localId,
          updates: { status: 'stalled', errorMessage: 'Still working after 60 minutes. Use Check again for its current status.' },
        });
        delete this.pollTimers[localId];
        return;
      }
      this.pollTimers[localId] = setTimeout(async () => {
        if (this.$isDestroyed) return;
        const jobs = this.$store.state.tax.trWorkFile.statementJobs;
        if (!jobs.find((j) => j.localId === localId)) {
          delete this.pollTimers[localId];
          return;
        }
        try {
          const response = await backendRest.get(this.jobStatusUrl(kind, jobId));
          const {
            status, processed, total, pdfUrl, errorMessage, sent, failed, skipped,
          } = response.data;
          // An email run's outcome is counts, not a file, so carry them onto the row.
          const emailCounts = kind === 'email'
            ? {
              sent: sent || 0,
              failed: failed || 0,
              skipped: skipped || 0,
              redirected: response.data.redirected || 0,
            }
            : {};
          if (status === 'complete') {
            this.updateStatementJob({
              localId,
              updates: {
                status: 'complete',
                processed: processed || 0,
                total: total || 0,
                ...emailCounts,
                pdfUrl: kind === 'email' ? null : `${backendRest.defaults.baseURL}/${pdfUrl}`,
              },
            });
            delete this.pollTimers[localId];
          } else if (status === 'error' || status === 'cancelled') {
            // A cancelled job is terminal too; without this the poll spins on it forever.
            this.updateStatementJob({ localId, updates: { status, errorMessage } });
            delete this.pollTimers[localId];
          } else {
            this.updateStatementJob({
              localId,
              updates: { processed: processed || 0, total: total || 0, ...emailCounts },
            });
            this.pollStatementJob(localId, jobId, attempt + 1, kind);
          }
        } catch (err) {
          this.updateStatementJob({ localId, updates: { status: 'error', errorMessage: err.message || 'Polling failed' } });
          delete this.pollTimers[localId];
        }
      }, 1500);
    },
    calculatePenaltyThrough() {
      // Safely parse the penalty date
      const penThroughDate = new Date();
      const penaltyCalcDate = destructureDate(penThroughDate);
      const { penaltyDate, penaltyRate } = this.taxSettingItem;
      if (!penaltyDate || !penaltyRate) {
        this.penaltyDateForStatement = toShortDate(penThroughDate);
      }
      if (penaltyDate <= penaltyCalcDate.day) {
        const nextMonth = penThroughDate.getMonth() + 1;
        const lastDayOfNextMonth = penaltyDate - 1;
        penThroughDate.setMonth(nextMonth, lastDayOfNextMonth);
      } else {
        const currentMonth = penThroughDate.getMonth();
        const lastDayOfCurrentMonth = penaltyDate - 1;
        penThroughDate.setMonth(currentMonth, lastDayOfCurrentMonth);
      }
      this.penaltyDateForStatement = toShortDate(penThroughDate);
    },

    async printInfoList() {
      const { jwt } = await this.reAuth();
      const criteria = this.criteriaState;
      const sortByColumn = this.dynamicSortBy();
      // if (sortByColumn === 'ownerName') {
      //   criteria.sortBy = [{ column: 'ownerName', direction: 'asc' }];
      // } else {
      //   criteria.sortBy = [{ column: 'mtgCode', direction: 'asc' }, { column: sortByColumn, direction: 'asc' }];
      // }
      criteria.sortBy = [{ column: sortByColumn, direction: 'asc' }];
      if (!criteria.name) {
        window.confirm('please select file name to proceed');
      } else if (this.tabsInit === 6) {
        // if selected filter index is 6, then we need to print the
        //  statement for the selected records

        if (!(this.selectedItems || []).length) {
          this.custumColrFlashMsg({ msg: 'Please select a record' });
          return;
        }
        criteria.ids = this.selectedItems.map((item) => item._id).join(',');
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));

        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
          'status=trworkfile',
          `singleLineInfo=${this.singleLineInfo}`,
          `fullLegalDescription=${this.fullLegalDescription}`,
          `wkstID=${Number(this.wkstNumber)}`,
          `isPageBreaks=${this.isPageBreaks}`,
          `isIncludeHalfPayAmounts=${this.isIncludeHalfPayAmounts}`,
          // Drives the penalty term and the fee effective-date cutoff. ISO on purpose: the
          // backend does new Date() on it, and YYYY-MM-DD parses as UTC midnight to match
          // how effectiveDate is stored.
          `penaltyDate=${toIsoDate(this.penaltyDateForStatement)}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        // A big list takes minutes to build and lands as tens of MB, which the browser's
        // PDF viewer will not render - it stalls and then reports "Failed to load PDF
        // document" even though the file is fine (Okmulgee, 2026-08-12). Past the
        // threshold it goes through the job queue instead, so the run is visible and the
        // finished file is handed over as a download.
        if (this.selectedItems.length > PICKLIST_ASYNC_MIN_RECORDS) {
          this.startStatementJob(queryString, 'picklist');
          return;
        }
        const to = `taxInquiry/pick-list/printlist${queryString}`;
        const url = `${backendRest.defaults.baseURL}/${to}`;
        window.open(url);
      } else {
        delete criteria.ids;
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
          'status=trworkfile',
          `singleLineInfo=${this.singleLineInfo}`,
          `fullLegalDescription=${this.fullLegalDescription}`,
          `wkstID=${Number(this.wkstNumber)}`,
          `isPageBreaks=${this.isPageBreaks}`,
          `isIncludeHalfPayAmounts=${this.isIncludeHalfPayAmounts}`,
          // Drives the penalty term and the fee effective-date cutoff. ISO on purpose: the
          // backend does new Date() on it, and YYYY-MM-DD parses as UTC midnight to match
          // how effectiveDate is stored.
          `penaltyDate=${toIsoDate(this.penaltyDateForStatement)}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        if (Number(this.selectedRecordsCount) > PICKLIST_ASYNC_MIN_RECORDS) {
          this.startStatementJob(queryString, 'picklist');
          return;
        }
        const to = `taxInquiry/pick-list/printlist${queryString}`;
        const url = `${backendRest.defaults.baseURL}/${to}`;
        window.open(url);
      }
    },
    async printAddressLabel() {
      const { jwt } = await this.reAuth();
      const criteria = this.criteriaState;
      criteria.sortBy = this.buildLabelSortBy();
      if (!criteria.name) {
        window.confirm('please select file name to proceed');
      } else if (this.tabsInit === 6) {
        // if selected filter index is 6, then we need to print the
        //  statement for the selected records

        if (!(this.selectedItems || []).length) {
          this.custumColrFlashMsg({ msg: 'Please select a record' });
          return;
        }
        criteria.ids = this.selectedItems.map((item) => item._id).join(',');
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
          'status=trworkfile',
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const to = `taxInquiry/address-label${queryString}`;
        const url = `${backendRest.defaults.baseURL}/${to}`;
        window.open(url);
      } else {
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));

        delete criteria.ids;
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
          'status=trworkfile',
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const to = `taxInquiry/address-label${queryString}`;
        const url = `${backendRest.defaults.baseURL}/${to}`;
        window.open(url);
      }
    },
    async printFeesList() {
      const { jwt } = await this.reAuth();
      const criteria = this.criteriaState;
      if (!criteria.name) {
        window.confirm('please select file name to proceed');
      } else if (this.tabsInit === 6) {
        // if selected filter index is 6, then we need to print the
        //  statement for the selected records

        if (!(this.selectedItems || []).length) {
          this.custumColrFlashMsg({ msg: 'Please select a record' });
          return;
        }
        criteria.ids = this.selectedItems.map((item) => item._id).join(',');
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
          `printDetails=${this.printDetails}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/trWorkFile/feeList${queryString}`;
        window.open(url, '_blank');
      } else {
        delete criteria.ids;
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
          `printDetails=${this.printDetails}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/trWorkFile/feeList${queryString}`;
        window.open(url, '_blank');
      }
    },
    async printCourtesyLetterReport() {
      const { jwt } = await this.reAuth();
      const criteria = this.criteriaState;
      if (!criteria.name) {
        window.confirm('please select file name to proceed');
      } else if (this.tabsInit === 6) {
        // if selected filter index is 6, then we need to print the
        //  statement for the selected records

        if (!(this.selectedItems || []).length) {
          this.custumColrFlashMsg({ msg: 'Please select a record' });
          return;
        }
        criteria.ids = this.selectedItems.map((item) => item._id).join(',');
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));
        const params = [
          `filters=${encodedCriteria}`,
          `letterDate=${this.letterDate}`,
          `warrantFee=${this.warrantFee}`,
          `warrantDate=${this.warrantDate}`,
          `token=${jwt}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/trWorkFile/courtesy-letter${queryString}`;
        window.open(url, '_blank');
      } else {
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));

        delete criteria.ids;
        const params = [
          `filters=${encodedCriteria}`,
          `letterDate=${this.letterDate}`,
          `warrantFee=${this.warrantFee}`,
          `warrantDate=${this.warrantDate}`,
          `token=${jwt}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/trWorkFile/courtesy-letter${queryString}`;
        window.open(url, '_blank');
      }
    },
    printPersonalLienDocket() {
      this.personalLienDocketDialog = true;
    },
    async confirmPersonalLienDocket() {
      const { jwt } = await this.reAuth();
      const criteria = this.criteriaState;
      const sortByColumn = this.dynamicSortBy();
      criteria.sortBy = [{ column: sortByColumn, direction: 'asc' }];

      if (!criteria.name) {
        window.confirm('please select file name to proceed');
        return;
      }
      if (this.tabsInit === 6) {
        if (!(this.selectedItems || []).length) {
          this.custumColrFlashMsg({ msg: 'Please select a record' });
          return;
        }
        criteria.ids = this.selectedItems.map((item) => item._id).join(',');
      } else {
        delete criteria.ids;
      }
      const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));
      const params = [
        `token=${jwt}`,
        `filters=${encodedCriteria}`,
        `dateFiled=${toIsoDate(this.dateFiled)}`,
      ];
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/trWorkFile/personal-lien-docket${queryString}`;
      window.open(url, '_blank');
      this.personalLienDocketDialog = false;
    },
    async printInfoListByMTGCodeReport() {
      const { jwt } = await this.reAuth();
      const criteria = this.criteriaState;
      if (!criteria.name) {
        window.confirm('please select file name to proceed');
      } else if (this.tabsInit === 6) {
        // if selected filter index is 6, then we need to print the
        //  statement for the selected records

        if (!(this.selectedItems || []).length) {
          this.custumColrFlashMsg({ msg: 'Please select a record' });
          return;
        }
        criteria.ids = this.selectedItems.map((item) => item._id).join(',');
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/trWorkFile/infolist-by-mtgcode${queryString}`;
        window.open(url, '_blank');
      } else {
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));

        delete criteria.ids;
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/trWorkFile/infolist-by-mtgcode${queryString}`;
        window.open(url, '_blank');
      }
    },
    async printMobileHomeReport() {
      const { jwt } = await this.reAuth();
      const criteria = this.criteriaState;
      if (!criteria.name) {
        window.confirm('please select file name to proceed');
      } else if (this.tabsInit === 6) {
        // if selected filter index is 6, then we need to print the
        //  statement for the selected records

        if (!(this.selectedItems || []).length) {
          this.custumColrFlashMsg({ msg: 'Please select a record' });
          return;
        }
        criteria.ids = this.selectedItems.map((item) => item._id).join(',');
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/trWorkFile/mobile-home${queryString}`;
        window.open(url, '_blank');
      } else {
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));

        delete criteria.ids;
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/trWorkFile/mobile-home${queryString}`;
        window.open(url, '_blank');
      }
    },
    mergeTaxConfigForSave() {
      return taxConfigScope.mergeForPersist(this.editItemSetting);
    },
    async printNotificationLetter() {
      const { jwt } = await this.reAuth();
      const criteria = this.criteriaState;
      criteria.sortBy = [{ column: this.dynamicSortBy(), direction: 'asc' }];
      if (!criteria.name) {
        window.confirm('please select file name to proceed');
      } else if (this.tabsInit === 6) {
        // if selected filter index is 6, then we need to print the
        //  statement for the selected records

        if (!(this.selectedItems || []).length) {
          this.custumColrFlashMsg({ msg: 'Please select a record' });
          return;
        }
        criteria.ids = this.selectedItems.map((item) => item._id).join(',');
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));

        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
          `penaltyDate=${this.editItemSetting.accessorPenaltyDate}`,
          `lienDate=${this.editItemSetting.accessorLienDate}`,
          `publicationDate=${this.editItemSetting.accessorPublicationDate}`,
          `paymentForms=${this.editItemSetting.accessorPaymentForms}`,
          `printWithOwner=${this.editItemSetting.accessorPrintWithOwner || false}`,
          `printCareOfName=${this.editItemSetting.accessorPrintCareOfName || false}`,
          `displayTotalDue=${this.editItemSetting.accessorDisplayTotalDue}`,
          `includeBackTaxesInTotal=${this.editItemSetting.accessorIncludeBackTaxesInTotal}`,
        ];
        if (this.editItemSetting.accessorAddressee) {
          params.push(`addressee=${this.editItemSetting.accessorAddressee}`);
        }
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/trWorkFile/notification-letter${queryString}`;
        this.closeDelinquentDialog();
        window.open(url, '_blank');
      } else {
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));

        delete criteria.ids;
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
          `penaltyDate=${this.editItemSetting.accessorPenaltyDate}`,
          `lienDate=${this.editItemSetting.accessorLienDate}`,
          `publicationDate=${this.editItemSetting.accessorPublicationDate}`,
          `paymentForms=${this.editItemSetting.accessorPaymentForms}`,
          `printWithOwner=${this.editItemSetting.accessorPrintWithOwner || false}`,
          `printCareOfName=${this.editItemSetting.accessorPrintCareOfName || false}`,
          `displayTotalDue=${this.editItemSetting.accessorDisplayTotalDue}`,
          `includeBackTaxesInTotal=${this.editItemSetting.accessorIncludeBackTaxesInTotal}`,
        ];

        if (this.editItemSetting.accessorAddressee) {
          params.push(`addressee=${this.editItemSetting.accessorAddressee}`);
        }
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/trWorkFile/notification-letter${queryString}`;

        // for tax setting update
        const payload = {
          calledScope: 'taxConfig',
          item: this.mergeTaxConfigForSave(),
          previousItem: this.originalTaxSetting,
          isLogAudit: true,
        };
        await this.updateConfig(payload);
        // if (ok) {
        //   this.originalTaxSetting = cloneItem(this.editItemSetting);
        // }
        this.callToUpdateTaxGlobalVariable();

        this.closeDelinquentDialog();
        window.open(url, '_blank');
      }
    },
    async exportUrl({ formatFile }) {
      let mongoId = '';
      let collectionName = '';
      let fileName = '';
      let itemData = [];
      const criteria = {
        type: 'export',
        program: 'TAX',
      };
      await this.loadTransformMappers({
        criteria,
        fields: { ...transformMapperListFields },
        baseCrudKey: 'transform-mapper-list',
      }).then(() => {
        itemData = this.items('transform-mapper-list');
      });
      for (let i = 0; i < (itemData || []).length > 0; i += 1) {
        const item = itemData[i];
        if (item.fileName === formatFile) {
          fileName = item.fileName;
          mongoId = item._id;
          collectionName = item.collectionName;
        }
      }
      const { jwt } = await this.reAuth();
      const { name } = this.criteriaState;

      const ifPaidBy1 = this.editItem.ifPaidBy1 ? toIsoDate(this.editItem.ifPaidBy1) : null;
      const ifPaidBy2 = this.editItem.ifPaidBy2 ? toIsoDate(this.editItem.ifPaidBy2) : null;
      const ifPaidBy3 = this.editItem.ifPaidBy3 ? toIsoDate(this.editItem.ifPaidBy3) : null;
      // eslint-disable-next-line max-len
      const penaltyThru = this.penaltyDateForStatement ? toIsoDate(this.penaltyDateForStatement) : null;

      const scanline = this.statementSettingItem.scanline || '';
      const backendURL = backendRest.defaults.baseURL;
      const encodedName = encodeURIComponent(name);
      const url = `${backendURL}/transmap/export?fileHeaders=true&id=${mongoId}&fileName=${fileName}&collectionName=${collectionName}&name=${encodedName}&ifPaidBy1=${ifPaidBy1}&ifPaidBy2=${ifPaidBy2}&ifPaidBy3=${ifPaidBy3}&penaltyThru=${penaltyThru}&scanline=${scanline}&program=TAX&token=${jwt}`;
      if (url && url !== '' && !url.match(/NaN/) && !url.match(/\/$/)) {
        window.open(url, '_blank');
      }
    },
    // Cert Mail upload file for COVIUS / WALZ, an .xlsx as of 2026-09 (was TR_CSV.csv).
    // exportUrl resolves the transform-mapper profile BY FILE NAME, so this string has to
    // match the profile's fileName exactly or the button silently produces no download.
    async certMailExport() {
      await (this.exportUrl({ formatFile: 'TR_CERT_MAIL.xlsx' }) || '');
    },
    async delqTaxCsvExport() {
      await (this.exportUrl({ formatFile: 'TR_Delq_Tax_CSV.csv' }) || '');
    },
    async delqTaxTextExport() {
      await (this.exportUrl({ formatFile: 'TR_Delq_Tax_TXT.txt' }) || '');
    },
    async mtgCoExport() {
      await (this.exportUrl({ formatFile: 'TR_Mtg_Co_TXT.txt' }) || '');
    },
    async trExportCsv() {
      await (this.exportUrl({ formatFile: 'TR_EXPORT_CSV.csv' }) || '');
    },
    async printCertifiedMailersReport() {
      const { jwt } = await this.reAuth();
      const criteria = this.criteriaState;
      if (!criteria.name) {
        window.confirm('please select file name to proceed');
      } else if (this.tabsInit === 6) {
        // if selected filter index is 6, then we need to print the
        //  statement for the selected records

        if (!(this.selectedItems || []).length) {
          this.custumColrFlashMsg({ msg: 'Please select a record' });
          return;
        }
        criteria.ids = this.selectedItems.map((item) => item._id).join(',');
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));

        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/trWorkFile/certified-mailers${queryString}`;
        window.open(url, '_blank');
      } else {
        const encodedCriteria = encodeURIComponent(JSON.stringify(criteria));

        delete criteria.ids;
        const params = [
          `token=${jwt}`,
          `filters=${encodedCriteria}`,
        ];
        if (this.devSetting && this.devSetting.isTestEnvironment) {
          params.push('isTestCafe=1');
        }
        const queryString = generateQueryString(params);
        const url = `${backendRest.defaults.baseURL}/trWorkFile/certified-mailers${queryString}`;
        window.open(url, '_blank');
      }
    },
    handleEmailInfoList() {
      const itemData = this.item(this.baseCrudKey);
      const criteria = this.criteriaState;

      const encodedCriteria = JSON.stringify(criteria);
      this.editEmailItem.filters = encodedCriteria;
      this.editEmailItem.emailAdd = itemData.emailAddess;
      this.editEmailItem.bccEmailAddress = this.statementSettingItem.bccEmailAddress;
      this.editEmailItem.subjectLine = this.statementSettingItem.subjectLine;
      this.editEmailItem.subjectBody = this.statementSettingItem.subjectBody;
      this.setIsVisible([this.emailStatementCrudKeyTR, true]);
    },

    // The criteria the grid holds carry its skip/limit (page) — strip them, because the run
    // covers the whole filtered list. The server drops them too; doing it here as well keeps
    // the preview the operator sees and the run they start reading from the same thing.
    bulkEmailCriteria() {
      const {
        skip, limit, ids, ...rest
      } = this.criteriaState || {};
      return { ...rest, sortBy: this.buildLabelSortBy() };
    },
    async refreshBulkEmailPreview() {
      const preview = await this.previewBulkEmailStatements({
        criteria: this.bulkEmailCriteria(),
        excludeAlreadySent: this.bulkEmailExcludeAlreadySent,
      });
      if (preview) this.bulkEmailPreview = preview;
      return preview;
    },
    onToggleResendAlreadySent(resend) {
      this.bulkEmailExcludeAlreadySent = !resend;
      // The counts change with the toggle, so re-ask rather than leave a stale number next
      // to a Send button.
      this.refreshBulkEmailPreview();
    },
    async handleBulkEmailStatements() {
      if (!this.criteriaState.name) {
        this.custumColrFlashMsg({ msg: 'Please select a file name to proceed.' });
        return;
      }
      this.bulkEmailExcludeAlreadySent = true;
      const preview = await this.refreshBulkEmailPreview();
      if (!preview) return;
      if (!preview.total) {
        this.custumColrFlashMsg({ msg: 'No records match the current filter.' });
        return;
      }
      if (!preview.willSend && !preview.skippedAlreadySent) {
        this.custumColrFlashMsg({ msg: 'None of the records in this list have an email address.' });
        return;
      }
      this.bulkEmailSettings.bccEmailAddress = this.statementSettingItem.bccEmailAddress || '';
      this.bulkEmailSettings.subjectLine = this.statementSettingItem.subjectLine || '';
      this.bulkEmailSettings.subjectBody = this.statementSettingItem.subjectBody || '';
      this.bulkEmailDialog = true;
    },
    async executeBulkEmailStatements() {
      this.bulkEmailStarting = true;
      const localId = Math.random().toString(36).slice(2);
      const label = `${this.buildJobLabel(this.criteriaState)} · Email`;
      try {
        const result = await this.startBulkEmailStatementsRun({
          criteria: this.bulkEmailCriteria(),
          emailSettings: this.bulkEmailSettings,
          penaltyDate: toIsoDate(this.penaltyDateForStatement),
          wkstNumber: this.wkstNumber,
          label,
          excludeAlreadySent: this.bulkEmailExcludeAlreadySent,
        });
        if (!result) return;
        this.bulkEmailDialog = false;
        // Joins the same queue the print runs use, so progress is read from the server and
        // survives a refresh, a second tab or a pod restart.
        this.addStatementJob({
          localId,
          jobId: result.runId,
          kind: 'email',
          label,
          status: 'running',
          processed: result.skipped || 0,
          total: result.total || 0,
          pdfUrl: null,
          errorMessage: null,
        });
        this.pollStatementJob(localId, result.runId, 0, 'email');
      } finally {
        this.bulkEmailStarting = false;
      }
    },
    openEmailRunLog(job) {
      this.emailLogRunId = job.jobId;
      this.emailLogRun = null;
      this.emailLogRows = [];
      this.emailLogTotalCount = 0;
      this.emailLogStatusFilter = '';
      this.emailLogDialog = true;
      // Assigning options fires the deep watcher below, and v-data-table emits its own
      // options update on mount — so the load is left to those rather than called here as
      // well, which fetched the same page two or three times on every open.
      this.emailLogOptions = { page: 1, itemsPerPage: 100 };
    },
    async reloadEmailLog() {
      if (!this.emailLogRunId) return;
      this.emailLogLoading = true;
      try {
        const { page = 1, itemsPerPage = 100 } = this.emailLogOptions || {};
        const data = await this.loadBulkEmailRunLog({
          runId: this.emailLogRunId,
          status: this.emailLogStatusFilter || undefined,
          skip: (page - 1) * itemsPerPage,
          limit: itemsPerPage,
        });
        if (!data) return;
        this.emailLogRun = data.run;
        this.emailLogRows = data.rows;
        this.emailLogTotalCount = data.totalCount;
      } finally {
        this.emailLogLoading = false;
      }
    },
    emailLogStatusClass(status) {
      if (status === 'sent') return 'success--text';
      if (status === 'failed') return 'error--text';
      // Not a failure, but must not read as a success either — nobody was emailed.
      if (status === 'redirected') return 'orange--text text--darken-3';
      return 'grey--text text--darken-1';
    },
    // Opened by navigation rather than XHR so the browser saves the file straight to disk;
    // authenticateToken accepts the ?token= form for exactly this case.
    openEmailLogCsv(statusFilter) {
      const params = [`token=${getRawJwt()}`];
      if (statusFilter) params.push(`status=${encodeURIComponent(statusFilter)}`);
      const url = `${backendRest.defaults.baseURL}/taxInquiry/pick-list/emailStatement/run/${this.emailLogRunId}/log.csv${generateQueryString(params)}`;
      window.open(url, '_blank');
    },
    exportEmailLog() {
      this.openEmailLogCsv('');
    },
    // The skipped set on its own, so those taxpayers can be handed to a printed mailing.
    exportEmailLogSkipped() {
      this.openEmailLogCsv('skipped-no-email,skipped-already-sent');
    },
    async retryFailedForLoggedRun() {
      const result = await this.retryFailedBulkEmails({ runId: this.emailLogRunId });
      if (!result) return;
      const localId = Math.random().toString(36).slice(2);
      const label = `Retry · ${(this.emailLogRun && this.emailLogRun.label) || 'email run'}`;
      this.addStatementJob({
        localId,
        jobId: result.runId,
        kind: 'email',
        label,
        status: 'running',
        processed: 0,
        total: result.total || 0,
        pdfUrl: null,
        errorMessage: null,
      });
      this.pollStatementJob(localId, result.runId, 0, 'email');
      this.emailLogDialog = false;
    },
    // Still used by the single-record Info List email below, which is unchanged: one send,
    // in the foreground, finished long before a session could expire under it.
    getAuthToken() {
      return getRawJwt();
    },
    async handleEmail() {
      // const itemData = this.item(this.baseCrudKey);
      const {
        bccEmailAddress, emailAdd, subjectBody, subjectLine, filters,
      } = this.editEmailItem;

      const item = {
        email: emailAdd,
        bccEmailAddress,
        subject: subjectLine,
        subjectBody,
        filters,
        token: this.getAuthToken(),
        status: 'trworkfile',
        singleLineInfo: this.singleLineInfo,
        fullLegalDescription: this.fullLegalDescription,
        isPageBreaks: this.isPageBreaks,
        isIncludeHalfPayAmounts: this.isIncludeHalfPayAmounts,
        // Keep the emailed Info List on the same "as of" date as the printed one
        penaltyDate: toIsoDate(this.penaltyDateForStatement),
      };
      this.sendMailTR({ item });
    },
  },
  beforeDestroy() {
    // Clean up any pending auto-save timeout
    if (this.autoSaveTimeout) {
      clearTimeout(this.autoSaveTimeout);
    }
    // Clear all statement poll timers so they don't fire against a destroyed instance
    Object.keys(this.pollTimers).forEach((id) => {
      clearTimeout(this.pollTimers[id]);
      delete this.pollTimers[id];
    });
  },
};

</script>
<style scoped>
.print-ctnr {
  display: flex;
  flex-direction: column;
  border: 1px solid lightgray;
  max-width: 500px;
  padding: 1rem;

}

.btns-ctnr {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.btns {
  display: flex;
  flex-direction: column;
  max-width: 200px;
}
.footer {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
.print-stmt {
  border: 1px solid lightgray;
  padding: 1rem;
}
.stmt-setting {
  border: 1px solid lightgray;
  padding: 1rem;
}
.flex-total {
  display: flex;
  gap: 12rem;
}

.print-order-border {
  border: 1px solid #ccc;
  border-radius: 12px;
  padding: 8px;
  margin: 4px 0;
}

.preview-text {
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px;
  font-family: monospace;
  font-size: 12px;
  max-height: 100px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>
